import type {z} from "zod";

import {CreateLeadBody} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {leadFieldLabelIds} from "../../../messages/leads.messages";

const createCompany = CreateLeadBody.shape.company;
const createProfile = createCompany.shape.partyProfile;
const createPhone = createProfile.shape.phone;

export const createLeadCompanyNameSchema = requiredStringSchema(
  createCompany.shape.companyName,
  leadFieldLabelIds.companyName,
);
export const createLeadAddressSchema = requiredStringSchema(
  createProfile.shape.address.shape.address,
  leadFieldLabelIds.address,
);

export const createLeadFormSchema = zod.object({
  companyName: createLeadCompanyNameSchema,
  address: createLeadAddressSchema,
  country: createProfile.shape.country,
  phoneNumber: createPhone.shape.nationalNumber,
  phonePrefix: createPhone.shape.regionCode,
  websiteUrl: createProfile.shape.websiteUrl,
  logoUrl: CreateLeadBody.shape.logoUrl,
  type: CreateLeadBody.shape.environments,
});
export type CreateLeadFormPayload = z.output<typeof createLeadFormSchema>;

export const draftCreateLeadFormSchema = createLeadFormSchema.partial();
export type DraftCreateLeadFormPayload = z.output<typeof draftCreateLeadFormSchema>;
